const SupportIcon = () => (
  <svg width="66" height="49" viewBox="0 0 66 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28 43.571C45.989 43.571 60.57 28.99 60.57 11 60.571-6.989 45.99-21.571 28-21.571 10.01-21.571-4.572-6.99-4.572 11c0 17.989 14.583 32.571 32.572 32.571z"
      fill="none"
    />
    <path
      d="m38.154 8.775-3.106 2.265c-1.549 1.216-2.189.902-2.189-.35V8.775a1.724 1.724 0 0 1-1.718-1.719V.181c0-.945.773-1.718 1.718-1.718h6.875v-3.008H24.18V10.05l.184.27c.918 1.288 1.023 1.833.416 2.643-.426.307.048 1.589 1.112 2.646 1.63 1.618 4.348 3.004 5.015 1.867.812-1.384 4.251.281 4.125 1.635-.348 1.487-2.167 2.016-3.688 2.242-2.5.208-5.119-1.065-7.164-2.795v7.23h15.554V8.774h-1.58z"
      fill="#f1f3f6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.328 7.056V.181c0-.945-.773-1.718-1.719-1.718h-9.324c-.945 0-1.719.773-1.719 1.718v6.875c0 .946.774 1.72 1.72 1.72v.633l.868-.634h8.455c.946 0 1.72-.773 1.72-1.719z"
      fill="#d3d9df"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.033 19.11c.049-.526-.443-1.101-1.11-1.524-.475.566-1.618.289-2.795-.368a.95.95 0 0 0-.22.258c-.668 1.138-3.385-.249-5.015-1.867-1.065-1.057-1.539-2.34-1.113-2.646.608-.81.502-1.355-.416-2.643a18.414 18.414 0 0 0-.283-.411 3.901 3.901 0 0 0-.442.938c-.352 1.135-.129 2.51.298 3.49 1.17 2.687 4.65 6.022 8.308 6.847 1.267-.297 2.506-.873 2.788-2.073z"
      fill="#f1f3f6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.734 30.314v-4.526H24.18v4.526a2.836 2.836 0 0 0 2.827 2.827h9.9a2.836 2.836 0 0 0 2.827-2.827z"
      fill="#d3d9df"
    />
    <path
      d="M27.725 28.064c-.771 0-1.4.629-1.4 1.4 0 .771.629 1.4 1.4 1.4.772 0 1.4-.629 1.4-1.4 0-.771-.629-1.4-1.4-1.4zM31.995 16.096c-.813 0-1.457.328-1.817.923a.518.518 0 0 1-.13.013c-.725 0-2.325-.817-3.55-2.033-.676-.672-.947-1.3-1.003-1.558 1.003-1.37.403-2.447-.425-3.61-.605-.901-1.273-1.792-2.168-1.956a1.362 1.362 0 0 0-.245-.022c-.78 0-1.552.632-1.584.659-.594.492-1.098 1.27-1.35 2.08-.444 1.433-.12 3.051.332 4.088.746 1.715 2.305 3.59 4.17 5.017 2.138 1.636 4.474 2.537 6.575 2.537.207 0 .414-.008.616-.025l.054-.006c2.558-.38 4.038-1.354 4.399-2.896l.013-.058.006-.059c.035-.379-.046-.966-.635-1.613-.782-.858-2.153-1.481-3.258-1.481zm-.75 4.402a5.753 5.753 0 0 1-.445.018c-3.923 0-7.985-3.799-9.17-6.522-.313-.72-.57-1.908-.265-2.892.152-.49.468-.988.805-1.267.123-.103.342-.217.46-.253.203.102.546.511 1.02 1.217l.014.02c.752 1.055.718 1.234.48 1.559-.216.21-.348.502-.374.838-.067.842.528 2.021 1.517 3.002 1.267 1.26 3.31 2.533 4.762 2.533.713 0 1.281-.298 1.599-.84.053-.091.298-.096.347-.096.422 0 1.005.2 1.485.508.454.292.65.57.689.686-.24.733-1.222 1.233-2.923 1.49z"
      fill="#3a414e"
    />
    <path
      d="M46.61-2.397h-6.016v-3.916A3.69 3.69 0 0 0 36.907-10H18.5a3.69 3.69 0 0 0-3.686 3.687v36.626A3.69 3.69 0 0 0 18.498 34h18.408a3.69 3.69 0 0 0 3.687-3.687V9.635h6.015a2.581 2.581 0 0 0 2.578-2.578V.182a2.581 2.581 0 0 0-2.578-2.579zM18.5-8.28h18.407a1.97 1.97 0 0 1 1.968 1.968v.908H16.531v-.908A1.97 1.97 0 0 1 18.5-8.281zM36.906 32.28H18.5a1.97 1.97 0 0 1-1.968-1.968v-3.666h22.344v3.666a1.97 1.97 0 0 1-1.968 1.968zm1.968-7.353H16.531V-3.686h22.344v1.29h-6.016A2.581 2.581 0 0 0 30.281.181v6.875c0 1.12.719 2.076 1.719 2.43v1.204c0 1.88 1.27 1.975 1.524 1.975.573 0 1.222-.299 2.042-.94l2.868-2.091h.441v15.293zm8.594-17.871a.86.86 0 0 1-.86.859h-8.455a.86.86 0 0 0-.506.165l-3.107 2.265-.024.018c-.378.297-.633.443-.79.514a2.25 2.25 0 0 1-.008-.188V8.776a.86.86 0 0 0-.86-.86.86.86 0 0 1-.859-.858V.182a.86.86 0 0 1 .86-.86h13.75a.86.86 0 0 1 .859.86v6.875z"
      fill="#3a414e"
    />
    <path
      d="M41.867 2.76h-1.273V1.486a.86.86 0 1 0-1.72 0V2.76h-1.273a.86.86 0 1 0 0 1.718h1.274v1.274a.86.86 0 0 0 1.719 0V4.478h1.273a.86.86 0 0 0 0-1.718z"
      fill="#3a414e"
    />
  </svg>
);

type SupportIconBackgroundProps = { className: string };

const SupportIconBackground = ({ className }: SupportIconBackgroundProps) => (
  <svg
    width="66"
    height="49"
    viewBox="0 0 66 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M24.25-24.258a7.5 7.5 0 0 1 7.5 0L56.659-9.876a7.5 7.5 0 0 1 3.75 6.495V25.38a7.5 7.5 0 0 1-3.75 6.495L31.75 46.258a7.5 7.5 0 0 1-7.5 0L-.659 31.876a7.5 7.5 0 0 1-3.75-6.495V-3.38a7.5 7.5 0 0 1 3.75-6.495L24.25-24.258z"
      stroke="none"
    />
  </svg>
);

export default Object.assign(SupportIcon, { Background: SupportIconBackground });
